function distanceFilter($translate, bbLocale, GeneralOptions) {
    'ngInject';

    return function (distanceInKilometres, roundBy) {

        if (!distanceInKilometres) {
            return '';
        }

        let distance = distanceInKilometres;

        let useMiles;

        switch (GeneralOptions.distanceUnit) {
            case 'kilometre': case 'kilometer':
                break;
            case 'mile':
                useMiles = true;
                break;
            case 'locale': default:
                useMiles = bbLocale.getLocale().match(/^(en|en-gb|en-us)$/gi);
                break;
        }

        if (useMiles) {
            distance *= 0.621371192;
        }

        if (roundBy) {
            distance = Math.round(distance * Math.pow(10, roundBy)) / Math.pow(10, roundBy);
        }

        const unit = useMiles
            ? $translate.instant('CORE.FILTERS.DISTANCE.MILES')
            : $translate.instant('CORE.FILTERS.DISTANCE.KILOMETRES');

        distance = `${distance} ${unit}`;

        return distance;
    };
}

/**
 * @ngdoc filter
 * @name distance
 * @kind function
 *
 * @description
 * Formats distance using current locale.
 *
 * @param {number} distance_in_km Distance in kilometres
 * @param {integer} round_by The number of decimal places to round by

 * @returns {string} Formatted distance
 *
 *

 <example module="distanceExample">
 <file name="index.html">
 <script>
 angular.module('distanceExample', [])
 .controller('ExampleController', ['$scope', function($scope) {
 $scope.distance = 10;
 }]);
 </script>
 <div ng-controller="ExampleController">
 <span>Price: {{distance | distance:1}}</span><br/>
 </div>
 </file>
 </example>
 */
angular
    .module('BB')
    .filter('distance', distanceFilter);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_filters/distance.filter.js